<!-- @format -->

<fudis-dialog *transloco="let t">
  <fudis-dialog-content>
    <fudis-form [titleVariant]="'lg'" [title]="t('TIMELINE.SELECT_COURSE_UNITS.TITLE_EDIT')" [level]="1">
      <fudis-form-content class="fudis-pb-xxl">
        <fudis-body-text class="fudis-mb-sm">
          <transloco
            [key]="'TIMELINE.SELECT_COURSE_UNITS.TIME_COURSE_UNITS_TO_PERIOD'"
            [params]="{
              name: data.studyPeriodData.name | localizedString,
              validity: data.studyPeriodData.valid | localDateRange,
            }" />
        </fudis-body-text>

        <fudis-expandable
          [title]="t('TIMELINE.SELECT_COURSE_UNITS.INFO_EXPANDABLE.TITLE')"
          [level]="2"
          [variant]="'lite'"
          [padding]="'small'">
          <ng-template fudisExpandableContent class="fudis-mb-none">
            <ul>
              <li>{{ t("TIMELINE.SELECT_COURSE_UNITS.INFO_EXPANDABLE.INFO_1") }}</li>
              <li>{{ t("TIMELINE.SELECT_COURSE_UNITS.INFO_EXPANDABLE.INFO_2") }}</li>
              <li>{{ t("TIMELINE.SELECT_COURSE_UNITS.INFO_EXPANDABLE.INFO_3") }}</li>
            </ul>
          </ng-template>
        </fudis-expandable>
        <fudis-expandable
          class="fudis-mb-md"
          [title]="t('TIMELINE.TIME_COURSE_UNIT.INFO_EXPANDABLE_2.TITLE')"
          [level]="2"
          [variant]="'lite'"
          [padding]="'small'">
          <ng-template fudisExpandableContent>
            <ul>
              <li>{{ t("TIMELINE.TIME_COURSE_UNIT.INFO_EXPANDABLE_2.INFO_1") }}</li>
              <li>{{ t("TIMELINE.TIME_COURSE_UNIT.INFO_EXPANDABLE_2.INFO_2") }}</li>
            </ul>
          </ng-template>
        </fudis-expandable>

        <fudis-grid [columns]="1" [rowGap]="'sm'">
          @if (educationPhaseStudies$ | async; as educationPhaseStudies) {
            @for (phase of educationPhaseStudies; track phase.id; let phaseIndex = $index) {
              <fudis-grid-item class="fudis-pb-md">
                <fudis-heading [level]="2" [variant]="'md'">{{ phase.label }}</fudis-heading>
                <fudis-multiselect
                  [label]="t('TIMELINE.SELECT_COURSE_UNITS.COURSE_UNITS')"
                  [control]="form.controls.selectedStudies.at(phaseIndex)"
                  [variant]="'autocompleteDropdown'"
                  [placeholder]="t('TIMELINE.SELECT_COURSE_UNITS.SEARCH_PLACEHOLDER')"
                  [selectionClearButton]="false">
                  <ng-template fudisSelectOptions>
                    @for (group of phase.optionGroups; track group.id) {
                      <fudis-multiselect-group [label]="group.label">
                        @for (option of group.options; track option) {
                          <fudis-multiselect-option [data]="option" />
                        }
                      </fudis-multiselect-group>
                    }
                  </ng-template>
                </fudis-multiselect>
              </fudis-grid-item>
            }
          }
        </fudis-grid>
      </fudis-form-content>
      <fudis-form-actions>
        <fudis-button fudisDialogClose [variant]="'secondary'" [label]="t('SIS_COMPONENTS.BUTTON.CANCEL')" />
        <fudis-button fudisFormSubmit [formValid]="form.valid" (handleClick)="save()" [label]="t('SIS_COMPONENTS.BUTTON.SAVE')" />
      </fudis-form-actions>
    </fudis-form>
  </fudis-dialog-content>
</fudis-dialog>
